import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AdminBaseEditComponent } from 'src/modules/sm-base/components/admin-base-edit/admin-base-edit.component';
import { FrontendField } from 'src/modules/sm-base/netgen/FrontendField';
import { FrontendFieldType } from 'src/modules/sm-base/netgen/FrontendFieldType';
import { FrontendForm } from 'src/modules/sm-base/netgen/FrontendForm';
import { ProjectPlanningTools } from '../../models/project-planning-tools.model';
import { ProjectType } from '../../netgen/ProjectType';
import { Utils } from 'src/modules/utils/shared/utils';

@Component({
    selector: 'app-edit-project-type',
    templateUrl: '../../../sm-base/components/admin-base-edit/admin-base-edit.component.html',
    styleUrl: '../../../sm-base/components/admin-base-edit/admin-base-edit.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditProjectTypeComponent extends AdminBaseEditComponent<ProjectType> {

    definition = ProjectPlanningTools.definitionProjectType;

    getForm(): FrontendForm {
        return this.app.tForm("entity.ProjectType.fields", new FrontendForm([
            new FrontendField("title", "", FrontendFieldType.string, { 
                mandatory: true,
                maxLength: 30
            }),
            new FrontendField("color", "", FrontendFieldType.color, { predefinedColors: Utils.getMaterialColors()})                            
        ]));
    }
    
}
